import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=693ab588&scoped=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=693ab588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693ab588",
  null
  
)

export default component.exports